import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user : {},
        configuration: [],
        deviceListTableFields: [
            // {
            //     key: 'selected',
            //     sortable: false,
            //     stickyColumn: true,
            //     label_t: '✓',
            //     visible: true,
            //     order: 1,
            //     width: 30,
            //     class: 'text-center p-0',
            // },
            {
                key: 'settings',
                sortable: false,
                stickyColumn: true,
                visible: true,
                order: 2,
                label_t: 'device_list.coll.header.settings',
                width: 30,
                class: 'text-center',
            },
            {
                key: 'status',
                label_t: 'device_list.coll.header.status',
                sortable: true,
                visible: true,
                order: 3
            },
            // {
            //     key: 'id',
            //     label_t: 'id',
            //     sortable: true,
            //     filtered: true,
            //     // filterByFormatted: true
            // },

            {
                key: 'customId',
                label_t: 'device_list.coll.header.id',
                sortable: true,
                filtered: true,
                width: 70,
                visible: true,
                order: 4
            },
            {
                key: 'imei',
                label_t: 'device_list.coll.header.imei',
                sortable: true,
                filtered: true,
                width: 150,
                visible: true,
                order: 5
                // filterByFormatted: true
            },
            {
                key: 'type',
                label_t: 'device_list.coll.header.type',
                sortable: true,
                filtered: true,
                width: 130,
                filteredType: 'select',
                dictionaryName: 'deviceType',
                visible: true,
                order: 6
            },
            {
                key: 'lastContactName',
                label_t: 'device_list.coll.header.last_contact',
                sortable: true,
                visible: true,
                order: 7
            },
            {
                key: 'lastContactTime',
                label_t: 'device_list.coll.header.last_contact_time',
                sortable: true,
                visible: true,
                order: 8
            },
            {
                key: 'settingsUpdateTime',
                label_t: 'device_list.coll.header.settings_update_time',
                sortable: true,
                visible: true,
                order: 9
            },
            {
                key: 'firmwareUpdateTime',
                label_t: 'device_list.coll.header.firmware_update_time',
                sortable: true,
                visible: true,
                order: 10
            },
            {
                key: 'firmwareCurrent',
                label_t: 'device_list.coll.header.firmware',
                sortable: true,
                filtered: true,
                width: 100,
                visible: true,
                order: 11
            },
            {
                key: 'distributor',
                label_t: 'device_list.coll.header.distributor',
                sortable: true,
                visible: true,
                filtered: true,
                order: 12
            },
            {
                key: 'distributorIdentity',
                label_t: 'device_list.coll.header.distributor_identity',
                sortable: true,
                visible: true,
                filtered: true,
                order: 13
            },
            {
                key: 'sim1',
                label_t: 'device_list.coll.header.sim1',
                sortable: false,
                visible: false,
                filtered: true,
                order: 14
            },
            {
                key: 'sim2',
                label_t: 'device_list.coll.header.sim2',
                sortable: false,
                visible: false,
                filtered: true,
                order: 15
            },
            {
                key: 'trafficModel',
                label_t: 'device_list.coll.header.traffic_model',
                sortable: false,
                visible: false,
                filtered: true,
                order: 16
            },
            {
                key: 'registeredNumber',
                label_t: 'device_list.coll.header.registered_number',
                sortable: false,
                visible: false,
                filtered: true,
                order: 17
            },
            {
                key: 'object',
                label_t: 'device_list.coll.header.object',
                sortable: false,
                visible: false,
                filtered: true,
                order: 18
            },
            {
                key: 'description',
                label_t: 'device_list.coll.header.description',
                sortable: false,
                visible: false,
                filtered: true,
                order: 18
            },
        ],
        packetsHistoryTableFields: [
            {
                key: 'id',
                label_t: 'id',
                sortable: false,
                filtered: false,
                visible: true,
                width: 10,
                // filterByFormatted: true
            },
            {
                key: 'date',
                sortable: false,
                stickyColumn: true,
                visible: true,
                order: 2,
                label_t: 'packet_list.coll.header.date',
                width: 30,
                class: 'text-center',
            },
            {
                key: 'latitude',
                label_t: 'packet_list.coll.header.latitude',
                sortable: false,
                visible: true,
                width: 500,
                order: 3
            },
            {
                key: 'longitude',
                label_t: 'packet_list.coll.header.longitude',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'glonass',
                label_t: 'packet_list.coll.header.satellites',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'speed',
                label_t: 'packet_list.coll.header.speed',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'gps',
                label_t: 'packet_list.coll.header.gps',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'gsm',
                label_t: 'packet_list.coll.header.gsm',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'mv',
                label_t: 'packet_list.coll.header.mv',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'voltage',
                label_t: 'packet_list.coll.header.voltage',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'acc',
                label_t: 'packet_list.coll.header.acc',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'output',
                label_t: 'packet_list.coll.header.output',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
            {
                key: 'input',
                label_t: 'packet_list.coll.header.input',
                sortable: false,
                filtered: false,
                width: 10,
                visible: true,
                order: 4,
            },
        ],
        lang: localStorage.getItem('lang') || process.env.VUE_APP_DEFAULT_LANG,
        theme: localStorage.getItem('theme') || 'light',
        deviceListFilter: {
            id: null,
            imei: null,
            customId: null,
            type: null,
            sim1: null,
            sim2: null,
            trafficModel: null,
            registeredNumber: null,
            object: null,
            description: null,
        },
        deviceList: null,
        deviceSensorConfig: [],
    },
    mutations: {
        auth_request(state){
            state.status = 'loading'
        },
        auth_success(state, token){
            state.status = 'success'
            state.token = token
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state){
            state.status = ''
            state.token = ''
        },
        addConfiguration(state, payload) {
            state.configuration[payload.configuration.deviceTypeId] = payload.configuration.configuration;
        },
        selLang(state, payload) {
            localStorage.setItem('lang', payload.lang)
            state.lang = payload.lang
        },
        clearLang() {
            localStorage.removeItem('lang')
        },
        updateDeviceListTableFields(state, payload) {
            state.deviceListTableFields = payload;
        },
        updateDeviceListFilter(state, payload) {
            state.deviceListFilter = payload;
        },
        updateDeviceList(state, deviceList) {
            state.deviceList = deviceList;
        },
        clearDeviceList(state) {
            state.deviceList = null;
        },
        saveDeviceSensorsConfig(state, payload) {
            const stored = state.deviceSensorConfig.find(q => q.device === payload.device);
            if (!stored) {
                state.deviceSensorConfig.push(payload);
            } else {
                stored.config = payload.config;
            }
        }
    },
    actions: {
        login({commit}, user){
            return new Promise((resolve, reject) => {
                commit('auth_request')
                axios.post('/web/login', new URLSearchParams(user).toString()
                    )
                    .then(resp => {

                        const token = resp.data.access_token
                        localStorage.setItem('token', token)
                        axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', token)
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
        logout({commit}){
            return new Promise((resolve) => {
                commit('logout')
                localStorage.removeItem('token')
                localStorage.removeItem('futureAvailable')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            })
        },
        loadConfiguration: (context, deviceTypeId) => {
            return axios.get('api/v1/device-types/'+deviceTypeId + '/configuration?_locale=ru', {
                // params: {
                //     id: this.id,
                //     alias: this.alias,
                // }
            })
                .then((response) => {
                    // console.log('2. server response:' + response.data)
                    context.commit('addConfiguration', {deviceTypeId: deviceTypeId, configuration: response.data});

                });

            // let {data} = axios.get('api/v1/device-types//'+deviceTypeId + '/configuration?_locale=ru');
        },
    },
    getters : {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        getConfiguration: state => (deviceTypeId) => {
            return state.configuration[deviceTypeId];
        },
        getLang: state => state.lang,
        getTheme: state => state.theme,
    }
})
